<div class="topHead">
    <a href="javascript:void(0);" class="adminBack" [routerLink]="['/organisation']"><img
            src="assets/images/admin/backarrow.png" /> Back to organisation Management</a>
    <!-- <div class="logout">
        <b>{{adminData.first_name+" " + adminData.last_name}}</b>
        <a href="javascript:void(0);" (click)="logout()"><img src="assets/images/admin/power.png" /> </a>
    </div> -->
    <div class="logout">
        <app-log-out class="logout"></app-log-out>
    </div>
</div>
<div class="centerWrap">
    <div class="formHeading">
        <h2>Create Organisation</h2>
        <p>Please add the following information to create a new organisation</p>
    </div>
    <form [formGroup]="orgForm">
        <div class="formArea">
            <div class="col-12 col-md-6">
                <div class="commanInput">
                  <mat-form-field class="example-full-width">
                      <mat-label>Organisation Name</mat-label>
                      <input matInput formControlName="organisation_name" [ngClass]="{ 'is-invalid': submitted && f.organisation_name.errors }" autocomplete="off">
                  </mat-form-field>
                  <div *ngIf="submitted && f.organisation_name.errors">
                    <span *ngIf="f.organisation_name.errors.required" class="text-mute text-danger errorText">This
                        field is required</span>
                </div>
                <div *ngIf="submitted && org_error">
                    <span  class="text-mute text-danger errorText">{{org_error}}</span>
                </div>
              </div>
          </div>


            <div class="col-12 col-md-6">
                <div class="commanRadio">
                    <div class="title">Organisation Type</div>
                    <mat-radio-group formControlName="organisation_type">
                        <mat-radio-button value=1>Internal</mat-radio-button>
                        <mat-radio-button value=2>External</mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf="submitted && f.organisation_type.errors">
                        <span *ngIf="f.organisation_type.errors.required" class="text-mute text-danger errorText">This
                            field is required</span>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <div class="commanSelect singleSelect">
                    <mat-form-field appearance="fill">
                    <mat-label>Validity</mat-label>
                    <mat-select formControlName="validity" [ngClass]="{ 'is-invalid': submitted && f.validity.errors }">
                        <mat-option value="">None</mat-option>
                        <mat-option *ngFor="let value of validity" [value]="value.value">{{value.viewValue}}</mat-option>
                    </mat-select>
                    </mat-form-field> 
                    <div *ngIf="submitted && f.validity.errors">
                        <span *ngIf="f.validity.errors.required" class="text-mute text-danger errorText">This field is required</span>
                    </div>
                </div>
            </div>
            <div class="d-flex w-100 mt-5 align-items-center justify-content-center">
                <a href="javascript:void(0);" class="backPage ml-2 mr-2" [routerLink]="['/organisation']">Cancel</a>
                <a href="javascript:void(0);" *ngIf="!status" class="btn btn-primary btn-sm ml-2 mr-2" (click)="createOrgUser(orgForm.value)">Create Organisation{{status}}</a>
                <a href="javascript:void(0);"  *ngIf="status ==1" class="btn btn-primary btn-sm ml-2 mr-2" (click)="editOrg(orgForm.value)">Update Organisation{{status}}</a>
               
            </div>
        </div>
    </form>
</div>